import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private readonly toastService: ToastrService) {}

  success(message: string) {
    this.toastService.success(message);
  }

  error(message: string) {
    this.toastService.error(message);
  }

  warning(message: string) {
    this.toastService.warning(message);
  }

  info(message: string) {
    this.toastService.info(message);
  }
}
